export default __webpack_public_path__ + "75405186e0d71a13288d331ac886b6c9.png";